/**
 * スポットのmutations
 */
const mutations = {

  /**
   * 地点リスト検索条件を設定
   */
  setSearchParams: (state, payload) => {
    state.searchParams = Object.assign({}, payload);  // view更新検知のため別オブジェクトにする
  },

  /**
   * おすすめスポット検索を利用しているかを設定
   */
  setRecommended: (state, payload) => {
    state.isRecommended = payload;
  },
  /**
   * 地点リスト検索結果を設定（スポット）
   */
  setSearchResultSpots: (state, payload) => {
    state.searchResultSpots = payload;
  },

  /**
   * 地点リスト検索結果を設定（住所
   */
  setSearchResultAddresses: (state, payload) => {
    state.searchResultAddresses = payload;
  },

  /**
   * 検索中フラグを設定（スポット）
   */
  isSearchingSpot: (state, payload) => {
    state.isSearchingSpot = payload;
  },

  /**
   * 検索中フラグを設定（住所）
   */
  isSearchingAddress: (state, payload) => {
    state.isSearchingAddress = payload;
  },

  /**
   * 検索エラーメッセージIDを設定（スポット）
   */
  setErrorMessageIdSpot: (state, payload) => {
    state.errorMessageIdSpot = payload;
  },

  /**
   * 検索エラーメッセージIDを設定（住所）
   */
  setErrorMessageIdAddress: (state, payload) => {
    state.errorMessageIdAddress = payload;
  },

  /**
   * 地点詳細情報を設定
   */
  spotDetail: (state, payload) => {
    state.spotDetail = payload;
  },

  /**
   * 地図に表示する地点リストを設定
   */
  setResultSpots: (state, payload) => {
    state.resultSpots = payload;
  },

  /**
   * 地点検索結果リストでホバー中または地点詳細表示中の地点を設定
   */
  setFocusedPoi(state, payload) {
    state.focusedPoi = payload;
  },

  /**
   * MapPageにて、一時的に選択されたスポットをセットする
   */
  setTapSpot(state, payload) {
    state.tapSpot = payload;
  },

  /**
   * スポットのサジェストをセットする
   */
  setSpotSuggestList(state, payload) {
    state.spotSuggestList = payload;
  },

  /**
   * サジェストから選ばれたスポット
   */
  setSelectedSpotNameInSuggest(state, payload) {
    state.selectedSpotNameInSuggest = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：駐車場
   */
  setFilterParking(state, payload) {
    state.filterParking = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：Wi-Fi
   */
  setFilterWiFi(state, payload) {
    state.filterWiFi = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：クレジットカード
   */
  setFilterCreditCard(state, payload) {
    state.filterCreditCard = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：コンセントあり
   */
  setFilterPlug(state, payload) {
    state.filterPlug = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：多言語対応
   */
  setFilterMultilingual(state, payload) {
    state.filterMultilingual = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：バリアフリー
   */
  setFilterBarrierFree(state, payload) {
    state.filterBarrierFree = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：ヴィーガン
   */
  setFilterVegan(state, payload) {
    state.filterVegan = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：高評価
   */
  setFilterHighLate(state, payload) {
    state.filterHighLate = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：記事スポット
   */
  setFilterArticleSpot(state, payload) {
    state.filterArticleSpot = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：座席数
   */
  setFilterNumSeats(state, payload) {
    state.filterNumSeats = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：地図で表示しているエリア
   */
  setFilterShowArea(state, payload) {
    state.filterShowArea = payload;
  },

  /**
   * スポット検索フィルタ設定保存用：現在地周辺
   */
  setFilterCurrentLocation(state, payload) {
    state.filterCurrentLocation = payload;
  },

  /**
   * ユーザーの現在位置を保存
   */
  setCurrentLocation(state, payload) {
    if (!payload.hasOwnProperty('lon') || !payload.hasOwnProperty('lat')) {
      state.currentLocation.lat = null;
      state.currentLocation.lon = null;
    }
    state.currentLocation.lat = payload.lat;
    state.currentLocation.lon = payload.lon;
  },

  setPoiSearchLog(state, payload) {
    state.poiSearchLog = payload;
  },

};

export {mutations as default};
